import { typographyPrimitives as r } from "../../primitives/typography.mjs";
const i = {
  ...r
};
export {
  i as variant
};
